export enum RouteUrls {
  Home = '',
  VideoGenerator = 'video-generator/:id',
  Account = 'account',
  Basket = 'basket',
  Order = 'order',
  OrderWithId = 'order/:id',
  OrderPlaced = 'order-placed',
  Faq = 'faq',
  About = 'about',
  Contact = 'contact',
  Privacy = 'privacy',
  Terms = 'terms',
  PageNotFound = 'page-not-found',
}
